import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["ARTWORK_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["ARTWORK_MODULE"],
  },
];

export default routes;
